import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IDeleteResultVm } from '../delete-result-vm.model';
@Injectable({ providedIn: 'root' })
export class AccountDeleteService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/AccountDelete`;
  }
  delete(authKey: string | undefined, email: string | undefined, accountGuid?: string): Observable<IDeleteResultVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (accountGuid !== undefined && accountGuid !== null) {
      params = params.set('accountGuid', accountGuid.toString());
    }
    if (authKey !== undefined && authKey !== null) {
      params = params.set('authKey', authKey.toString());
    }
    if (email !== undefined && email !== null) {
      params = params.set('email', email.toString());
    }
    return this.http.delete<IDeleteResultVm>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
